(function () {
  "use strict";

  if (window.__terraLealabLinkerMounted) return;
  window.__terraLealabLinkerMounted = true;

  var LEALAB_URL = "https://lealabshop.com/";
  var REFERENCE_SOURCE = "\\b(?:https?:\\/\\/)?(?:www\\.)?(?:LEANZA[ \\t\\u00a0]+LABORATORI|LEALABSHOP(?:\\.COM)?|LEALAB)\\b(?:[®™])?";
  var EXCLUDED_SELECTOR = [
    "a",
    "button",
    "input",
    "textarea",
    "select",
    "option",
    "label",
    "form",
    "script",
    "style",
    "noscript",
    "code",
    "pre",
    "svg",
    "summary",
    "template",
    "[contenteditable]",
    "[role='button']",
    "[role='link']",
    "[hidden]",
    "[aria-hidden='true']",
    "[data-no-lealab-link]",
    ".terra-partner-card",
    "[data-terra-partners] .terra-partner-item"
  ].join(",");

  function hasReference(value) {
    return new RegExp(REFERENCE_SOURCE, "i").test(value || "");
  }

  function isExcluded(textNode) {
    var parent = textNode && textNode.parentElement;
    return !parent || Boolean(parent.closest(EXCLUDED_SELECTOR));
  }

  function createLink(label) {
    var link = document.createElement("a");
    link.className = "terra-lealab-link";
    link.href = LEALAB_URL;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    link.setAttribute("data-terra-lealab-linked", "");
    link.textContent = label;
    return link;
  }

  function linkTextNode(textNode) {
    if (!textNode || isExcluded(textNode) || !hasReference(textNode.nodeValue)) return 0;

    var value = textNode.nodeValue;
    var pattern = new RegExp(REFERENCE_SOURCE, "gi");
    var fragment = document.createDocumentFragment();
    var lastIndex = 0;
    var match;
    var linked = 0;

    while ((match = pattern.exec(value))) {
      if (match.index > lastIndex) fragment.appendChild(document.createTextNode(value.slice(lastIndex, match.index)));
      fragment.appendChild(createLink(match[0]));
      lastIndex = pattern.lastIndex;
      linked += 1;
    }

    if (!linked) return 0;
    if (lastIndex < value.length) fragment.appendChild(document.createTextNode(value.slice(lastIndex)));
    textNode.parentNode.replaceChild(fragment, textNode);
    return linked;
  }

  function linkLeanzaReferences(root) {
    if (!root) return 0;
    if (root.nodeType === Node.TEXT_NODE) return linkTextNode(root);
    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_NODE && root.nodeType !== Node.DOCUMENT_FRAGMENT_NODE) return 0;
    if (root.nodeType === Node.ELEMENT_NODE && root.matches(EXCLUDED_SELECTOR)) return 0;

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        return !isExcluded(node) && hasReference(node.nodeValue)
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_REJECT;
      }
    });
    var nodes = [];
    var current;
    var linked = 0;

    while ((current = walker.nextNode())) nodes.push(current);
    nodes.forEach(function (node) { linked += linkTextNode(node); });
    return linked;
  }

  window.linkLeanzaReferences = linkLeanzaReferences;

  function mount() {
    if (!document.body) return;
    linkLeanzaReferences(document.body);

    if (!("MutationObserver" in window)) return;
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes, linkLeanzaReferences);
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", mount, { once: true });
  else mount();

  document.addEventListener("shopify:section:load", function (event) {
    linkLeanzaReferences(event.target);
  });
}());
